class NavMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {
    const navBtn = document.querySelector('.nav-btn');
    const navBtnClose = document.querySelector('.nav-btn-close');
    const navBtnSp = document.querySelector('#nav-btn');
    const navMenuArea = document.querySelector('#nav-menuArea');
    const Overlay = document.querySelector('.js-overlay');
    const navTxt = document.querySelector('.nav-ttl');
    // const navTxtPc = document.querySelector('.nav-ttl-pc');
    const body = document.querySelector('body');
    let navLink = document.querySelectorAll('.navLink');

    navBtn.addEventListener('click', () => {

      console.log('et');
      navMenuArea.classList.add('is-open');
      Overlay.classList.add('is-active');
      // navTxtPc.classList.toggle('is-active');
      body.classList.add('is-active');

      // if(navTxtPc.classList.contains('is-active')){
      //   navTxtPc.textContent = 'CLOSE';
      // } else {
      //   navTxtPc.textContent = 'MENU';
      // }

    });
    navBtnClose.addEventListener('click', () => {

      navMenuArea.classList.remove('is-open');
      Overlay.classList.remove('is-active');
      // navTxtPc.classList.toggle('is-active');
      body.classList.remove('is-active');

      // if(navTxtPc.classList.contains('is-active')){
      //   navTxtPc.textContent = 'CLOSE';
      // } else {
      //   navTxtPc.textContent = 'MENU';
      // }

    });

    navBtnSp.addEventListener('click', () => {

      navMenuArea.classList.toggle('is-open')
      Overlay.classList.toggle('is-active')
      navTxt.classList.toggle('is-active')
      body.classList.toggle('is-active')

      if(navTxt.classList.contains('is-active')){
        navTxt.textContent = 'CLOSE';
      } else {
        navTxt.textContent = 'MENU';
      }

    });


    
    Overlay.addEventListener('click', () => {
      
      navMenuArea.classList.remove('is-open');
      Overlay.classList.remove('is-active');
      // navTxt.classList.remove('is-active');
      body.classList.remove('is-active');

    });

    navLink.forEach((link) => {
    
      link.addEventListener('click', () => {
        
        navMenuArea.classList.remove('is-open');
        Overlay.classList.remove('is-active');
        navTxt.classList.remove('is-active');
        body.classList.remove('is-active');
        navTxtPc.textContent = 'MENU';
        navTxt.textContent = 'MENU';
        
      });
    });


    // スクロール時の縮小（PCのみ）
    const headerWrap = '.js-header';
    if(isMobile()){

    }else{
      document.addEventListener("scroll", function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
        if (scrollTop > 500) {
            $(headerWrap).addClass("is-active");
        } else {
            $(headerWrap).removeClass("is-active");
        }
      });
    }
  }
}
